import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RegistrationProfileCostsHeroImage from '../../../../assets/images/registration-profile-costs-hero.png';
import { rubikTypographyStyles } from '../../../../shared/ui';

const Slide = styled.section.attrs({
  'data-ui': 'onboarding-costs-slide',
})`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(5)};
`;

const IntroSection = styled.div`
  margin-left: ${({ theme }) => theme.scale.px(31)};
  display: grid;
  gap: ${({ theme }) => theme.scale.px(4)};
`;

const Title = styled.h1`
  ${rubikTypographyStyles};
  margin: 0;
  width: ${({ theme }) => theme.scale.px(341)};
  font-size: ${({ theme }) => theme.scale.px(24)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(28)};
`;

const BulletList = styled.ul`
  width: ${({ theme }) => theme.scale.px(334)};
  margin: 0;
  margin-left: ${({ theme }) => theme.scale.px(-11)};
  padding-left: ${({ theme }) => theme.scale.px(24)};
  display: grid;
  gap: 0;
`;

const BulletItem = styled.li`
  ${rubikTypographyStyles};
  font-size: ${({ theme }) => theme.scale.px(15)};
  font-weight: 400;
  line-height: ${({ theme }) => theme.scale.px(18)};
`;

const Hero = styled.img`
  width: ${({ theme }) => theme.scale.px(487)};
  margin-left: ${({ theme }) => theme.scale.px(30)};
  height: auto;
  display: block;
`;

export function CostsSlide() {
  const { t } = useTranslation();

  return (
    <Slide>
      <IntroSection>
        <Title>{t('registrationProfileCosts.title')}</Title>
        <BulletList>
          <BulletItem>{t('registrationProfileCosts.bulletSignup')}</BulletItem>
          <BulletItem>{t('registrationProfileCosts.bulletMonthly')}</BulletItem>
          <BulletItem>
            {t('registrationProfileCosts.bulletWithdrawals')}
          </BulletItem>
        </BulletList>
      </IntroSection>

      <Hero alt="" aria-hidden src={RegistrationProfileCostsHeroImage} />
    </Slide>
  );
}
